export type LevelNumber = 1 | 2;
export const MinLevel: LevelNumber = 1;
export const MaxLevel: LevelNumber = 2;
